import { IPermission } from '@shared/interfaces/permission.interface';

export const Permissions: IPermission = {
  read: 'read-absence',
  create: 'create-absence',
  update: 'update-absence',
  delete: 'delete-absence'
};
